import { useEffect, useState } from "react";
import { useSearchStore } from "../../../store/search/searchStore";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import { useParams } from "react-router-dom";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import Table, { Column } from "../../../Components/Tables/Table";
import { HistoryLayoutDataOverViewDetails } from "../../../Data/testData";
import HistoryLayout from "../../../Layout/HistoryLaout";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import { getAsnDetails } from "../service/asnOverview.service";
import { ASN, Line } from "../model/asnOverview.model";
import { captializeString, formatDate, formatNumber } from "../../../Utility/Utility";
import Loader from "../../../Components/GlobalLoader/Loader";
import ViewMoreModal from "../../../Components/Modals/ViewMoreModal";
import { AsnDetailProps } from "../model/AsnOverview.type";



const AsnDetail: React.FC<AsnDetailProps> = ({
  columns,
  InboundASNOverviewData,
  data,
  setData,
  showViewModal,
  setViewModal,
  screenName,
  addUrl,
  listUrl,
  isHistoryEnabled,
  noOfrowsToDisplay,
}) => {
  const { id } = useParams<{ id: string }>();
  const pageName = `${screenName} (${id})`;
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const resetSearch = useSearchStore((state) => state.resetSearch);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    resetSearch();
    return () => {
      resetSearch();
    };
  }, [resetSearch]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  useEffect(() => {
    setData(null);
    getAsnDetails(id).then((response) => {
      setData(response.data ?? null);
      setLoading(false);
    });
  }, [id, setData]);
  const [isShowCanvas, setShowCanvas] = useState(false);
  const handelCanvas = () => {
    setShowCanvas(!isShowCanvas);
  };
  const handleViewClose = () => setViewModal(false);
  const onModalSubmit = () => {
    handleViewClose();
  };

  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );

  if (loading) {
    return <Loader />;
  }
  return data ? (
    <>
      <PageHeader
        addUrl={addUrl}
        listUrl={listUrl}
        viewType={true}
        isHistoryEnabled={isHistoryEnabled}
        historyData={[historyData]}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="mt-1 bg-white rounded py-1 px-4 d-flex flex column">
        <div className="checkin-details col-12 mt-2 dynamic-grid rounded ">
          {collapseStates[0] ? (
            <div className="checkin-details align-items-top d-flex bg-white col-12">
              <DynamicDetailGrid
                customClassName="col-10"
                isExpandable={false}
                columns={noOfrowsToDisplay}
                data={InboundASNOverviewData.ASNOverviewDefault}
              />

              <div className="col-2">
                <div className="align-self-center d-flex flex-row-reverse">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronDown /> : <ChevronUp />}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="checkin-details flex-column-reverse align-items-center d-flex bg-white">
              <div className="d-flex col-12">
                <div className="d-flex col">
                  <DynamicDetailGrid
                    customClassName="p-0 col"
                    isExpandable={false}
                    columns={2}
                    data={InboundASNOverviewData.ASNOverviewExpanded}
                  />
                 
                </div>
                <div className="d-flex flex-column mt-3">
                  {InboundASNOverviewData.BoxedData &&
                    InboundASNOverviewData.BoxedData.map(
                      (section: any, index: number) => {
                        const key = Object.keys(section)[0];
                        const items = section[key];

                        return (
                          <div className="d-flex flex-column justify-content-start align-items-end">
                            <div className="supplier position-relative px-4 py-3 mb-5">
                              <div className="floating-label fs-14 inbound-checkin-supplier position-absolute translate-middle px-2 bg-white">
                                {captializeString(key)}
                              </div>
                              {items.map((item: any, idx: number) => (
                                <div key={idx} className={""}>
                                  {item.value}
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      }
                    )}
                </div>

                <div className="col-1 ms-3">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse(0)}
                    >
                      {collapseStates[0] ? <ChevronDown /> : <ChevronUp />}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="mt-2 bg-white rounded py-1 px-4 h-100">
        <Table
          columns={columns}
          data={data?.lines ?? []}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
        />
      </div>
      <ViewMoreModal
        customClassName="header-border"
        show={showViewModal}
        content={data?.special_instructions}
        onModalSubmit={onModalSubmit}
      />
      <HistoryLayout
        isShowCanvas={isShowCanvas}
        showViewScanLogs={true}
        handelCanvas={handelCanvas}
        data={HistoryLayoutDataOverViewDetails}
      />
    </>
  ) : (
    <Loader />
  );
};
export default AsnDetail;
